export const fa = {
  dashboard: {
    overview: 'Resumen',
  },
  common: {
    languageChanged: 'Idioma cambiado',
  },
  translations: {
    server:
      'Este mensaje se genera dinámicamente en el servidor de Next.js y es renderizado por un Componente de Servidor de React para una experiencia de usuario rápida y fluida.',
    client:
      'Este mensaje es renderizado por un Componente Cliente de React, mostrando elementos interactivos y actualizaciones dinámicas sin recargas completas de la página.',
  },
  navigation: {
    dashboard: 'الرئيسية',
  },
} as const;
